<template>
  <!-- 会员关系设置 -->
  <div class="membership-bind">
    <el-form
      ref="dataForm"
      :model="dataForm"
      label-width="150px"
      label-position="left"
    >
      <SpCardContent>
        <el-form-item label="开启关系绑定：">
          <el-switch v-model="dataForm.is_bind" />
        </el-form-item>
      </SpCardContent>

      <!-- 新客绑定设定模块 -->
      <SpCardContent v-if="dataForm.is_bind">
        <div
          slot="header"
          class="header"
        >
          <div class="title">
            新客绑定设定
          </div>
        </div>
        <div class="form-item">
          <el-form-item label="绑定条件：">
            <el-checkbox
              v-model="dataForm.newcustomers.registered_node"
              disabled
            >
              完成注册
            </el-checkbox>
            <!-- <el-checkbox v-model="dataForm.newcustomers.paid_node">
              完成首次下单
            </el-checkbox> -->
            <div class="tips-box">
              <div class="tips-title">
                绑定条件解释
              </div>
              <ul>
                <li class="tips-list">
                  <div class="tips-list-title">
                    完成注册：
                  </div>
                  <div class="tips-list-content">
                    导购引导客户通过扫自己的导购码完成注册。
                  </div>
                </li>
                <!-- <li class="tips-list">
                  <div class="tips-list-title">
                    完成<span>首次</span>下单：
                  </div>
                  <div class="tips-list-content">
                    导购服务客户购买商品，通过扫自己的转发的物料完成<span>首次</span>下单。
                  </div>
                </li>
                <li class="tips-list">
                  <div class="tips-list-title">
                    完成注册&完成<span>首次</span>下单：
                  </div>
                  <div class="tips-list-content">
                    导购同时完成引导客户完成注册和首次下单，两个步骤需同一导购完成；<br>
                    当前条件客户完成注册后给予导购去完成首次下单条件的保护期，保护期内该导购需完成转发物料引导客户<span>首次</span>下单，方能绑定与客户的关系。
                  </div>
                </li> -->
              </ul>
            </div>
          </el-form-item>
          <!-- <el-form-item
            v-if="dataForm.newcustomers.registered_node && dataForm.newcustomers.paid_node"
            label="关系保护期："
          >
            <div class="view-flex view-flex-middle">
              <el-input
                v-model="dataForm.newcustomers.protect"
                class="input-m"
                placeholder="请输入内容"
              >
                <template slot="append">
                  天
                </template>
              </el-input>
              <div class="tips">
                同时勾选「完成注册」和「完成首次下单」时生效；导购引导客户完成注册后，在改保护期内客户无法与其他导购形成绑定关系，该导购引导客户完成首次下单后与其形成绑定关系。
              </div>
            </div>
          </el-form-item> -->
          <el-form-item label="绑定时长：">
            <div class="view-flex view-flex-middle">
              <el-input
                v-model="dataForm.newcustomers.duration"
                class="input-m"
                placeholder="请输入内容"
              >
                <template slot="append">
                  天
                </template>
              </el-input>
              <div class="tips">
                导购与客户产生绑定关系后，关系保留时长
              </div>
            </div>
          </el-form-item>
        </div>
      </SpCardContent>

      <!-- 老客绑定设定模块 -->
      <SpCardContent v-if="dataForm.is_bind">
        <div
          slot="header"
          class="header"
        >
          <div class="title">
            老客绑定设定
          </div>
        </div>
        <div class="form-item">
          <!-- <el-form-item label="绑定条件：">
            <el-checkbox v-model="dataForm.registered.paid_node">
              完成一笔订单
            </el-checkbox>
            <el-checkbox v-model="dataForm.registered.bind_node">
              手动绑定
            </el-checkbox>
            <div class="tips-box">
              <div class="tips-title">
                绑定条件解释
              </div>
              <ul>
                <li class="tips-list">
                  <div class="tips-list-title">
                    完成一笔订单：
                  </div>
                  <div class="tips-list-content">
                    导购服务客户购买商品，通过扫自己的转发的物料完成下单。
                  </div>
                </li>
                <li class="tips-list">
                  <div class="tips-list-title">
                    手动绑定：
                  </div>
                  <div class="tips-list-content">
                    导购将绑定二维码转发给客户，引导客户识别二维码绑定
                  </div>
                </li>
                <li class="tips-list">
                  <div class="tips-list-title">
                    完成一笔订单/手动绑定：
                  </div>
                  <div class="tips-list-content">
                    以上两个条件完成任一即可绑定
                  </div>
                </li>
              </ul>
            </div>
          </el-form-item> -->
          <el-form-item label="绑定时长：">
            <div class="view-flex view-flex-middle">
              <el-input
                v-model="dataForm.registered.duration"
                class="input-m"
                placeholder="请输入内容"
              >
                <template slot="append">
                  天
                </template>
              </el-input>
              <div class="tips">
                导购与客户产生绑定关系后，关系保留时长
              </div>
            </div>
          </el-form-item>
        </div>
      </SpCardContent>

      <!-- 客户关系延续模块 -->
      <SpCardContent v-if="dataForm.is_bind">
        <div
          slot="header"
          class="header"
        >
          <div class="title">
            客户关系延续
          </div>
          <div class="subtitle">
            <span
              class="tips"
            >若客户有绑定导购，在商品下单/分享商品后绑定关系将延续特定天数；填入0天则代表不延续。</span>
          </div>
        </div>
        <div class="form-item">
          <el-form-item label="关系延续节点：">
            <div class="checklist">
              <el-checkbox v-model="dataForm.continue.payment.is_open">
                下单&nbsp;&nbsp;
              </el-checkbox>
              <span :style="{ color: '#606266' }">
                关系延续
                <el-input
                  v-model="dataForm.continue.payment.continue"
                  class="input-m"
                  placeholder="请输入内容"
                >
                  <template slot="append">天</template>
                </el-input>
              </span>
            </div>

            <div class="checklist">
              <el-checkbox v-model="dataForm.continue.active.is_open">
                分享&nbsp;&nbsp;
              </el-checkbox>
              <span :style="{ color: '#606266' }">
                关系延续
                <el-input
                  v-model="dataForm.continue.active.continue"
                  class="input-m"
                  placeholder="请输入内容"
                >
                  <template slot="append">天</template>
                </el-input>
              </span>
            </div>

            <!-- <div class="tips">
              顾客与导购绑定关系可以通过上述2种方式延续
            </div> -->
          </el-form-item>
        </div>
      </SpCardContent>

      <!-- <div class="bind_bottom">
        <el-button class="submit-btn" type="primary" :loading="submitLoading" @click="onSubmit"
          >保存设置</el-button
        >
      </div> -->
    </el-form>

    <div class="fotter-toolbar">
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="onSubmit"
      >
        保存设置
      </el-button>
    </div>
  </div>
</template>

<script>
import { getSetting, setSetting } from '@/api/membership/membershipBind'
export default {
  data () {
    return {
      submitLoading: false,
      dataForm: {
        is_bind: false,
        newcustomers: {
          registered_node: true, //暂时默认修改为true，并且不可更改
          paid_node: false,
          protect: '',
          duration: ''
        },
        registered: {
          paid_node: false,
          bind_node: true, //暂时默认修改为true，并且不可更改
          duration: ''
        },
        continue: {
          payment: {
            is_open: false,
            continue: ''
          },
          active: {
            is_open: false,
            continue: ''
          }
        }
      }
    }
  },
  mounted () {
    this.getSetting()
  },
  methods: {
    // 获取导购配置
    async getSetting () {
      const data = await getSetting()

      //暂时默认修改为true，并且不可更改
      data.newcustomers.registered_node = true
      data.registered.bind_node = true

      if (data) {
        this.dataForm = data
      }
    },
    // 设置导购配置
    async setSettingFun (params) {
      const data = await setSetting(params).catch(() => {
        this.submitLoading = false
      })
      if (data) {
        this.submitLoading = false
        this.$message({ type: 'success', message: '保存成功' })
      }
    },
    // 保存
    onSubmit () {
      this.submitLoading = true
      if (!this.dataForm.is_bind) {
        let dataFormNoBind = {
          is_bind: this.dataForm.is_bind
        }
        this.setSettingFun(dataFormNoBind)
      } else {
        this.setSettingFun(this.dataForm)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  &-item__content {
    width: 550px;
  }
  .el-card {
    margin-bottom: 20px;
  }
  .el-input-group--append {
    width: 160px;
    margin-right: 10px;
  }
}
.el-form-item {
  width: 820px;
}

.membership-bind {
  padding-bottom: 20px;
}
.top-tips {
  margin-bottom: 35px;
}
.form-tips {
  display: flex;
  align-items: center;
  margin: -5px 0;
}
.form-title {
  font-size: 18px;
  color: #606266;
}
.checklist {
  display: block;
  margin-bottom: 20px;
}
.bind_bottom {
  width: 100%;
  display: flex;
  justify-content: center;
  .submit-btn {
    width: 300px;
  }
}
.tips-box {
  background-color: rgba(239, 239, 239, 1);
  padding: 10px 20px;
  color: #666666;
  line-height: 20px;
  .tips-title {
    color: #666;
    margin-bottom: 10px;
  }
  .tips-list {
    display: flex;
    font-size: 12px;
    color: #999;
    .tips-list-title {
      width: 180px;
    }
    .tips-list-content {
      flex: 1;
    }
    span {
      color: #409eff;
    }
  }
}

.setting-top {
  margin-bottom: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header {
  display: flex;
  margin-bottom: 10px;
  .title {
    font-size: 14px;
    color: #111;
    font-weight: 600;
    margin-right: 20px;
  }
  .subtitle {
    .tips {
      font-size: 12px;
      color: #999;
    }
    .el-button {
      padding: 0 10px;
      font-size: 12px;
    }
  }
}
</style>
